import { axios } from '@/utils/request'

const api = {
  centerList: '/adminapi/examecenter/centerList',
    centerDetail: '/adminapi/examecenter/centerDetail',
    editCenter: '/adminapi/examecenter/editCenter',
    deleteCenter: '/adminapi/examecenter/deleteCenter',
    centerDeleteAll: '/adminapi/examecenter/centerDeleteAll',
    applyList: '/adminapi/qcxj/applyList',
    applyDetail: '/adminapi/qcxj/applyDetail',
    editApply: '/adminapi/qcxj/editApply',
    applyMemberList: '/adminapi/qcxj/applyMemberList',
    kaojiMemberList: '/adminapi/qcxj/kaojiMemberList',
    centerDownloadUrl: '/adminapi/examecenter/centerDownloadUrl',
    applyDelete: '/adminapi/qcxj/applyDelete',
    getSetting: '/adminapi/qcxj/getSetting',
    setSetting: '/adminapi/qcxj/setSetting',
    getApplyOrderDetail: '/adminapi/qcxj/applyOrderDetail',
    applyOrderUnPayDetail: '/adminapi/qcxj/applyOrderUnPayDetail',
    checkApplyMemberOK: '/adminapi/qcxj/checkApplyMemberOK',
    editApplyOrder: '/adminapi/qcxj/editApplyOrder',
    getApplyUserDetail: '/adminapi/qcxj/memberDetail',
    editApplyUser: '/adminapi/qcxj/applyMemberEdit',
    refreshOrder: '/adminapi/qcxj/refreshOrder',
    deleteApplyUser: '/adminapi/qcxj/deleteApplyUser',
    deleteApplyUsers: '/adminapi/qcxj/deleteApplyUsers',
    addMemberAll: '/adminapi/qcxj/addMemberAll',

    deleteCenterUser: '/adminapi/examecenter/deleteCenterUser',
    addCenterUser: '/adminapi/examecenter/addCenterUser',
    getCenterUserList: '/adminapi/examecenter/centerUserList',
    provinceMapData: '/adminapi/qcxj/provinceMapData',
}

export default api

export function getCenterList(parameter) {
  return axios({
    url: api.centerList,
    method: 'get',
    params: parameter
  })
}

export function getCenterDetail(parameter) {
  return axios({
    url: api.centerDetail,
    method: 'get',
    params: parameter
  })
}
export function editCenter(parameter) {
  return axios({
    url: api.editCenter,
    method: 'post',
    data: parameter
  })
}
export function deleteCenter(parameter) {
  return axios({
    url: api.deleteCenter,
    method: 'post',
    data: parameter
  })
}

export function centerDeleteAll(parameter) {
    return axios({
        url: api.centerDeleteAll,
        method: 'post',
        data: parameter
    })
}

export function getApplyList(parameter) {
    return axios({
        url: api.applyList,
        method: 'get',
        params: parameter
    })
}

export function getApplyDetail(parameter) {
    return axios({
        url: api.applyDetail,
        method: 'get',
        params: parameter
    })
}
export function getApplyMemberList(parameter) {
    return axios({
        url: api.applyMemberList,
        method: 'get',
        params: parameter
    })
}
export function getKaojiMemberList(parameter) {
    return axios({
        url: api.kaojiMemberList,
        method: 'get',
        params: parameter
    })
}
export function getCenterDownloadUrl(parameter) {
    return axios({
        url: api.centerDownloadUrl,
        method: 'get',
        params: parameter
    })
}
export function editApply(parameter) {
    return axios({
        url: api.editApply,
        method: 'post',
        data: parameter
    })
}
export function applyDelete(parameter) {
    return axios({
        url: api.applyDelete,
        method: 'post',
        data: parameter
    })
}
export function setSetting(parameter) {
    return axios({
        url: api.setSetting,
        method: 'post',
        data: parameter
    })
}
export function getSetting(parameter) {
    return axios({
        url: api.getSetting,
        method: 'post',
        data: parameter
    })
}
export function getApplyOrderDetail(parameter) {
    return axios({
        url: api.getApplyOrderDetail,
        method: 'post',
        data: parameter
    })
}
export function getApplyOrderUnPayDetail(parameter) {
    return axios({
        url: api.applyOrderUnPayDetail,
        method: 'post',
        data: parameter
    })
}

export function checkApplyMemberOK(parameter) {
    return axios({
        url: api.checkApplyMemberOK,
        method: 'post',
        data: parameter
    })
}
export function editApplyOrder(parameter) {
    return axios({
        url: api.editApplyOrder,
        method: 'post',
        data: parameter
    })
}
export function getApplyUserDetail(parameter) {
    return axios({
        url: api.getApplyUserDetail,
        method: 'post',
        data: parameter
    })
}
export function editApplyUser(parameter) {
    return axios({
        url: api.editApplyUser,
        method: 'post',
        data: parameter
    })
}
export function deleteApplyUser(parameter) {
    return axios({
        url: api.deleteApplyUser,
        method: 'post',
        data: parameter
    })
}
export function deleteApplyUsers(parameter) {
    return axios({
        url: api.deleteApplyUsers,
        method: 'post',
        data: parameter
    })
}
export function addMemberAll(parameter) {
    return axios({
        url: api.addMemberAll,
        method: 'post',
        data: parameter
    })
}
export function refreshOrder(parameter) {
    return axios({
        url: api.refreshOrder,
        method: 'post',
        data: parameter
    })
}




export function deleteCenterUser(parameter) {
    return axios({
        url: api.deleteCenterUser,
        method: 'post',
        data: parameter
    })
}

export function addCenterUser(parameter) {
    return axios({
        url: api.addCenterUser,
        method: 'post',
        data: parameter
    })
}

export function getCenterUserList(parameter) {
    return axios({
        url: api.getCenterUserList,
        method: 'post',
        data: parameter
    })
}

export function provinceMapData(parameter) {
    return axios({
        url: api.provinceMapData,
        method: 'post',
        data: parameter
    })
}
